exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".onboardingInstall{background:#fff;position:fixed;top:0;left:0;width:100vw;height:100vh;text-align:center;display:flex;flex-direction:column;justify-content:center}.onboardingInstall .setup-logo-container{position:absolute;text-align:left;top:0}.onboardingInstall__content{max-width:550px;margin-left:auto;margin-right:auto;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./app/containers/onboardingInstallContainer.scss
// module id = 1349
// module chunks = 0